import { lazy, useEffect, useState } from 'react';
import './App.less';
import NotFound from './pages/NotFound';
import { PrivateRoute } from './router/privateRoute';
import { BrowserRouter as Router, Outlet, Route, Routes } from 'react-router-dom';
import { ROLE } from '@router/role';
import { RoleRoute } from '@router/roleRoute';
import { appRoutes } from '@router/routes';
import { ConfigProvider } from 'antd';
import { isEmpty } from 'lodash';
import Login from './pages/Login';
import { OpenSiteRoutes } from './router/openSiteRoute';
import AdminPage from './pages/Admin';
import Home from './pages/Home';
import Management from './pages/Admin/Management';
import Report from './pages/Admin/Management/Report';
import History from './pages/Admin/Management/History';
import ThuChiPage from './pages/Admin/ThuChi';
import AddThuChi from './pages/Admin/ThuChi/AddThuChi';
import Floor from './pages/Admin/Room/Floor';
import RoomCategory from './pages/Admin/Room/Category';
import ListSanPham from './pages/Admin/Service/Item';
import RoomPage from './pages/Admin/Room/Phong';
import AddFloor from './pages/Admin/Room/Floor/AddFloor';
import AddCategory from './pages/Admin/Room/Category/AddCategory';
import SanPhamCategory from './pages/Admin/Service/Category';
import AddCategorySanPham from './pages/Admin/Service/Category/AddCategory';
import AddSanPham from './pages/Admin/Service/Item/AddItem';
import PageLayoutAdmin from './layout/Main/admin';
import PageLayoutLogin from './layout/Main/login';
const MainCheckIn = lazy(() => import('@/pages/Main/SubPage/CheckIn'));
const PageLayout = lazy(() => import('./layout/Main'));
const Order = lazy(() => import('@/pages/Main/SubPage/Order'));

function App() {
    const [isAuth, setIsAuth] = useState(!!localStorage.getItem('token'));
    useEffect(() => {
        const handleEventKeyDown = (e: any) => {
            if (e.key === 'Enter' && !isEmpty(document.getElementsByClassName('ant-modal-confirm-body-wrapper'))) {
                document.getElementsByClassName('ant-modal-confirm-body-wrapper') &&
                    (
                        document.querySelector(
                            '.ant-modal-confirm-body-wrapper .ant-modal-confirm-btns .ant-btn-primary',
                        ) as HTMLElement
                    ).click();
            }
        };
        document.addEventListener('keydown', handleEventKeyDown);
        return () => {
            document.removeEventListener('keydown', handleEventKeyDown);
        };
    });

    useEffect(() => {
        setIsAuth(!!localStorage.getItem('token'));
    }, [localStorage.getItem('token')]);

    return (
        <ConfigProvider>
            <Router>
                <Routes>
                    <Route element={<OpenSiteRoutes isAuthenticated={isAuth} />}>
                        <Route element={<PageLayoutLogin />}>
                            <Route path={`${appRoutes.AUTH.LOGIN}`} element={<Login />} />
                        </Route>
                    </Route>
                    <Route element={<PrivateRoute isAuthenticated={isAuth} />}>
                        <Route element={<PageLayout />}>
                            <Route element={<RoleRoute />}>
                                <Route path={`${appRoutes.ADMIN.ROOT}`} element={<Management />} />
                                <Route path={`${appRoutes.MAIN.CHECK_IN}/:id`} element={<MainCheckIn />} />
                                <Route path={`${appRoutes.MAIN.ORDER}`} element={<Order />} />
                                <Route path={`${appRoutes.ADMIN.MANAGEMENT.ROOT}`} element={<Management />} />
                            </Route>
                        </Route>
                        <Route element={<PageLayoutAdmin />}>
                            <Route element={<RoleRoute />}>
                                <Route path={`${appRoutes.ADMIN.ROOM.FLOOR}`} element={<Floor />} />
                                <Route path={`${appRoutes.ADMIN.ROOM.FLOOR_ADD}`} element={<AddFloor />} />
                                <Route path={`${appRoutes.ADMIN.ROOM.FLOOR_UPDATE}/:id`} element={<AddFloor />} />
                                <Route path={`${appRoutes.ADMIN.ROOM.CATEGORY}`} element={<RoomCategory />} />
                                <Route path={`${appRoutes.ADMIN.ROOM.CATEGORY_ADD}`} element={<AddCategory />} />
                                <Route path={`${appRoutes.ADMIN.ROOM.CATEGORY_UPDATE}/:id`} element={<AddCategory />} />
                                <Route path={`${appRoutes.ADMIN.ROOM.ROOT}`} element={<RoomPage />} />
                                <Route path={`${appRoutes.ADMIN.SERVICE.ROOT}`} element={<SanPhamCategory />} />
                                <Route
                                    path={`${appRoutes.ADMIN.SERVICE.DANHMUC_ADD}`}
                                    element={<AddCategorySanPham />}
                                />
                                <Route
                                    path={`${appRoutes.ADMIN.SERVICE.DANHMUC_UPDATE}/:id`}
                                    element={<AddCategorySanPham />}
                                />
                                <Route path={`${appRoutes.ADMIN.SERVICE.ITEM}`} element={<ListSanPham />} />
                                <Route path={`${appRoutes.ADMIN.SERVICE.ITEM_ADD}`} element={<AddSanPham />} />
                                <Route path={`${appRoutes.ADMIN.SERVICE.ITEM_UPDATE}/:id`} element={<AddSanPham />} />
                                <Route path={`${appRoutes.ADMIN.MANAGEMENT.REPORT}`} element={<Report />} />
                                <Route path={`${appRoutes.ADMIN.MANAGEMENT.HISTORY}`} element={<History />} />
                                <Route path={`${appRoutes.ADMIN.THU_CHI.ROOT}`} element={<ThuChiPage />} />
                                <Route path={`${appRoutes.ADMIN.THU_CHI.THU_CHI_ADD}`} element={<AddThuChi />} />
                                <Route path={`${appRoutes.ADMIN.THU_CHI.THU_CHI_UPDATE}/:id`} element={<AddThuChi />} />
                            </Route>
                        </Route>
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
        </ConfigProvider>
    );
}

export default App;
